import { LoadingButton } from '@mui/lab';
import { Stack, TextField } from '@mui/material';
import Proptypes from 'prop-types';

import { useInput } from '../../hooks/useInput';
import { validateIccidRange } from '../../utils/iccid';

const IccidOrganizationRangeForm = ({ onSubmit, loading, disabled }) => {
  const [minIccid, handleChangeMinIccid] = useInput('');
  const [maxIccid, handleChangeMaxIccid] = useInput('');

  const minValue = minIccid.trim();
  const maxValue = maxIccid.trim();
  const error = minValue && maxValue ? validateIccidRange(minValue, maxValue) : null;

  return (
    <>
      <Stack spacing={3} sx={{ my: 2 }}>
        <TextField fullWidth placeholder="Min ICCID" value={minIccid} onChange={handleChangeMinIccid} />
      </Stack>
      <Stack spacing={3} sx={{ my: 2 }}>
        <TextField
          fullWidth
          placeholder="Max ICCID"
          value={maxIccid}
          onChange={handleChangeMaxIccid}
          error={!!error}
          helperText={error}
        />
      </Stack>
      <LoadingButton
        sx={{ my: 2 }}
        onClick={() => onSubmit('range', { minIccid: minValue, maxIccid: maxValue })}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        loading={loading}
        disabled={disabled || loading || !minValue || !maxValue || !!error}
      >
        Submit
      </LoadingButton>
    </>
  );
};
IccidOrganizationRangeForm.propTypes = {
  onSubmit: Proptypes.func,
  loading: Proptypes.bool,
  disabled: Proptypes.bool,
};
export default IccidOrganizationRangeForm;
